import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDate } from '../../../../utils/fmt';

const OpportunityEventListDetails = () => {
  const columns = [
    { label: 'Title', value: 'title' },
    { label: 'Start Date', value: (item) => fmtDate(item.start_date) },
    { label: 'Location', value: 'location' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/opportunity/event/details/' + encodedId;
  };
  return <ListTemplate fetchUrl={API_DOMAIN + API_ROUTES['opportunityEvent']} columns={columns} onAccessDetails={handleAccessDetails} />;
};

export default OpportunityEventListDetails;